import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Carregando...</div>;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // is_admin_premio na rota "/" redireciona para /avaliacao-premio
  if (user.is_admin_premio && !user.is_staff && !user.is_superuser && !user.is_coordenador && location.pathname === '/') {
    return <Navigate to="/avaliacao-premio" replace />;
  }

  return children;
}

export default ProtectedRoute;
